import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/modules/auth/Login.vue';
import {checkLang, checkLogin, checkPermissions} from '@/setup/router/guards';
import ProductsRouter from '@/modules/products/ProductsRouter';
import CategoriesRouter from '@/modules/categories/CategoriesRouter';
import AwardsRouter from '@/modules/awards/AwardsRouter';
import OffersRouter from '@/modules/offers/OffersRouter';
import HomeRouter from '@/modules/home/HomeRouter';
import RequestsRouter from '@/modules/requests/RequestsRouter';
//import IngredientsRouter from '@/modules/ingredients/IngredientRouter';
import UsersRouter from '@/modules/users/UsersRouter';
import ClientsRouter from '@/modules/clients/ClientsRouter';
import NotBought from '@/components/Shared/NotBought.vue';
import InsufficientPermissions from '@/components/Shared/InsufficientPermissions.vue';
import NotFound from '@/components/Shared/NotFound.vue';
import TablesRouter from '@/modules/tables/TablesRouter';
import PrintersRouter from '@/modules/printers/PrintersRouter';
import ReportsRouter from '@/modules/reports/ReportsRouter';
import SettingsRouter from '@/modules/settings/SettingsRouter';
import BoxReportRouter from '@/modules/reports/boxReport/BoxReportRouter';
import ZonesRouter from '@/modules/zones/ZonesRouter';
import BookingsRouter from '@/modules/bookings/BookingsRouter';
import ShiftRouter from '@/modules/shifts/ShiftRouter';
import BookingOptionRouter from '@/modules/booking-options/BookingOptionRouter';
//import StockReportRouter from '@/modules/reports/stocksReport/StockReportRouter';
import LanguageNotSupported from '@/components/Shared/LanguageNotSupported.vue';
//import ProviderRouter from '@/modules/providers/ProviderRouter';
//import PurchasesRouter from '@/modules/purchases/PurchasesRouter';
//import StocksRouter from '@/modules/stocks/StockRouter';
import ScreenRouter from '@/modules/screens/ScreenRouter';
import FamiliesRouter from '@/modules/families/FamiliesRouter';
import {BaseLink} from '@/core/standard/BaseLink';
import CashiersRouter from '@/modules/cashiers/CashiersRouter';
import SubdomainNotFound from '@/components/Shared/SubdomainNotFound.vue';
import ModifierRouter from '@/modules/modifiers/ModifierRouter';
import RecipesRouter from '@/modules/recipes/RecipesRouter';
import LocalDisabled from '@/components/Shared/LocalDisabled.vue';
//import RecipesRouter from '@/modules/recipes/RecipesRouter';
import DistributionRouter from '@/modules/distribution/DistributionRouter';
import StockRouter from '@/modules/stock/StockRouter';
import OptionRouter from '@/modules/modifier-options/OptionRouter';
import UserTimeTrackingRouter from '@/modules/users/userTimeTracking/UserTimeTrackingRouter'
import MaintenanceView from '@/components/Shared/MaintenanceView.vue'
Vue.use(Router);

const routerInstance = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: {name: 'requests'},
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {layout: 'NoLayout'},
    },
    ...ReportsRouter,
    ...HomeRouter,
    ...ProductsRouter,
    //...IngredientsRouter,
    ...OffersRouter,
    ...RequestsRouter,
    ...UsersRouter,
    ...AwardsRouter,
    // ...RolesRouter,
    ...ClientsRouter,
    ...TablesRouter,
    ...PrintersRouter,
    ...CategoriesRouter,
    ...SettingsRouter,
    ...BoxReportRouter,
    ...ZonesRouter,
    ...BookingsRouter,
    ...ShiftRouter,
    ...BookingOptionRouter,
    //...StockReportRouter,
    //...StocksRouter,
    //...ProviderRouter,
    //...PurchasesRouter,
    ...ScreenRouter,
    ...FamiliesRouter,
    ...CashiersRouter,
    ...ModifierRouter,
    ...RecipesRouter,
    //...DistributionRouter,
    ...DistributionRouter,
    ...StockRouter,
    ...OptionRouter,
    ...UserTimeTrackingRouter,
    {
      path: '/not-bought',
      name: 'not-bought',
      component: NotBought,
    },
    {
      path: '/insufficient-permissions',
      name: 'insufficient-permissions',
      component: InsufficientPermissions,
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
    },
    {
      path: '',
      name: 'subdomain-not-found',
      component: SubdomainNotFound,
      meta: {layout: 'NoLayout'},
    },
    {
      path: '/lang-not-supported',
      name: 'LanguageNotSupported',
      component: LanguageNotSupported,
    },
    {
      path: '',
      name: 'local-disabled',
      component: LocalDisabled,
      meta: {layout: 'NoLayout'},
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: MaintenanceView,
      meta: {layout: 'NoLayout'},
    },
  ],
});
routerInstance.beforeEach(async (to, from, next) => {
  const modules: string[] = to.meta.modules;
  const lockModule = to.meta.lockModule;
  const needGuard = to.matched.some((m) => m.meta.needGuard);
  if (BaseLink.notBoughtModules.includes(lockModule)) {
    return next({name: 'not-bought'});
  }
  //TODO: Fix
  if (modules?.length && modules.every((module) => BaseLink.disabledModules.includes(module))) {
    return next({name: '404'});
  }
  if (needGuard) {
    await checkLogin(to, from, next);
    await checkPermissions(to, from, next);
    await checkLang(to, from, next);
    next();
  } else {
    next();
  }
});
export default routerInstance;
